import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPaginationModule } from 'ngx-pagination';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';


export interface ViewComPallets {
  palletComplementaryValueNumber: string;
  palletComplementaryValueDate: string;
  palletComplementaryStatus: string;
  palletComplementaryWarehouseCode: string;
  warehouseCodeName: string;
  palletComplementaryCarrierCode: string;
  carrierName: string;
}

export interface ViewOprPallets {
  palletId: number;
  palletCode: string;
  palletWaybillCode: string;
  palletShipmentCode: string;
  palletDate: string;
  palletDeliveryType: string;
  palletDealerCode: string;
  dealerName: string;
  dealerOperatingAddressStreet: string;
  dealerOperatingAddressCity: string;
  palletStatus: string;
  palletActualDeliveryDate: string;
  palletEstimatedDeliveryDate: string;
  regionCode: string;
  regionName: string;
  showComPallets: boolean;
  comPallets: ViewComPallets[];
}


interface Client {
  clientCode: string;
  clientName?: string;
}

interface Brand {
  brandCode: string;
  brandName?: string;
}

interface ClientsBrands {
  clientCode: string;
  clientName?: string;
  brands: Brand[];
}

@Component({
  selector: 'app-returns-history',
  standalone: true,
  templateUrl: './returns-history.component.html',
  styleUrls: ['./returns-history.component.css'],
  imports: [FormsModule, CommonModule, TranslateModule, NgxPaginationModule]
})
export class ReturnsHistoryComponent implements OnInit {

  currentPage: number = 1;
  itemsPerPage: number = 25;

  oprPallets: ViewOprPallets[] = [];
  filteredOprPallets: ViewOprPallets[] = [];

  temp: ViewOprPallets[] = [];

  searchPalletCode: string = '';
  searchWaybillCode: string = '';
  dateStart: string = '';;
  dateEnd: string = '';

  dateError: string = '';
  isLoading: boolean = false;

  globalSearchTerm: string = '';
  palletStatus: string = '';     // "DELIVERED" | "PICKED_UP"

  selectedOprPallet: ViewOprPallets | null = null;
  showModal: boolean = false;

  showNotification = false;
  notificationMessage = '';

  filteredBrands: Brand[] = [];
  selectedBrands: Brand[] = [];
  filteredClients: Client[] = [];
  selectedClients: Client[] = [];
  clientsBrands: ClientsBrands[] = [];

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    const savedPage = localStorage.getItem('currentParcelPage');
    this.currentPage = savedPage ? +savedPage : 1;

    // Recupera anche itemsPerPage dal localStorage
    const savedItemsPerPage = localStorage.getItem('itemsPerPage');
    this.itemsPerPage = savedItemsPerPage ? +savedItemsPerPage : 25;

        const stored = localStorage.getItem('userFunctions');
    if(stored) {
      const parsed = JSON.parse(stored);
      this.clientsBrands = parsed.clients; 

      this.filteredClients = this.clientsBrands.map(cb => ({
        clientCode: cb.clientCode,
        clientName: cb.clientName,
      }))
      .sort((a, b) => {
        if (!a.clientName && !b.clientName) return 0;       
        if (!a.clientName) return 1;                        
        if (!b.clientName) return -1;                       
        return a.clientName.localeCompare(b.clientName);   
      });

      const allBrands: Brand[] = this.clientsBrands.flatMap(cb =>
        cb.brands.map(b => ({
          brandCode: b.brandCode,
          brandName: b.brandName,
        }))
      ).sort((a, b) => {
        if (!a.brandName && !b.brandName) return 0;       
        if (!a.brandName) return 1;                        
        if (!b.brandName) return -1;                       
        return a.brandName.localeCompare(b.brandName);   
      });

      this.filteredBrands = Array.from(
        new Map(allBrands.map(b => [b.brandCode, b])).values()
      );
    }

    this.oprPallets = [];
    this.filteredOprPallets = [];
  }

    getFilteredPallets(p: ViewOprPallets): ViewComPallets[] {
      return p.comPallets
        ?.filter(c => c.palletComplementaryValueNumber != null && c.palletComplementaryValueNumber !== '')
        .sort((a, b) => {
        const dateA = new Date(a.palletComplementaryValueDate).getTime();
        const dateB = new Date(b.palletComplementaryValueDate).getTime();
        if (dateA !== dateB) {
          return dateA - dateB; // crescente per data
        }

        const numA = Number(a.palletComplementaryValueNumber);
        const numB = Number(b.palletComplementaryValueNumber);

        return numA - numB; // crescente per numero
      });
    }


  onItemsPerPageChange(): void {
    this.currentPage = 1; // Reset alla prima pagina quando cambi il numero di elementi
    localStorage.setItem('itemsPerPage', this.itemsPerPage.toString());
  }

  resetItemsPerPage(): void {
    this.itemsPerPage = 25;
    this.currentPage = 1;
    localStorage.setItem('itemsPerPage', '25');
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    localStorage.setItem('currentParcelPage', page.toString());
  }

  applyFilters(): void {
    //this.resetItemsPerPage();
    this.loadData();
  }

  loadData(): void {
    if (this.searchWaybillCode === '' && this.searchPalletCode === '') {
      return;
    }

    this.isLoading = true;

    let clientsBrandsSelected: ClientsBrands[];
    if(this.filteredClients.length == 1) {
      this.selectedClients = [...this.filteredClients];
    }
    if (this.selectedClients.length > 0) {
      clientsBrandsSelected = this.selectedClients.map(sc => {
        // trovo il client originale da clientsBrands
        const originalClient = this.clientsBrands.find(cb => cb.clientCode === sc.clientCode);

        var filteredBrandsFromClient: Brand[] = [];
        if(this.selectedBrands.length > 0) {
          // brands effettivi = intersezione tra quelli del client e quelli selezionati
          filteredBrandsFromClient = (originalClient?.brands || []).filter(b =>
            this.selectedBrands.some(sb => sb.brandCode === b.brandCode)
          );
        }
        else {
          filteredBrandsFromClient = this.filteredBrands;
        }

        return {
          clientCode: sc.clientCode,
          clientName: sc.clientName,
          brands: filteredBrandsFromClient
        } as ClientsBrands;
      });
    } else if (this.selectedBrands && this.selectedBrands.length > 0) {
      // nessun client selezionato, ma brand sì
      clientsBrandsSelected = this.clientsBrands
        .map(cb => {
          const matchingBrands = cb.brands.filter(b =>
            this.selectedBrands.some(sb => sb.brandCode === b.brandCode)
          );
          if (matchingBrands.length > 0) {
            return {
              clientCode: cb.clientCode,
              clientName: cb.clientName,
              brands: matchingBrands
            } as ClientsBrands;
          }
          return null;
        })
        .filter(cb => cb !== null) as ClientsBrands[];

    } else {
      // né client né brand selezionati → ritorno tutto
      clientsBrandsSelected = this.clientsBrands;
    }

    const body = {
      waybillCode: this.searchWaybillCode || null,
      palletCode: this.searchPalletCode || null,
      clientsBrands: clientsBrandsSelected
    };

    this.http.post<ViewOprPallets[]>(
      `${environment.apiUrl}/pallets/search`,
      body
    ).subscribe({
      next: (data) => {

        this.currentPage = 1;

        this.oprPallets = data.map(p => ({
          ...p,
          showComPallets: true
        }));

        this.filteredOprPallets = this.oprPallets;
        this.temp = [...this.oprPallets];
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Errore durante la chiamata HTTP:', err);
        this.isLoading = false;
      }
    });
  }

  onGlobalSearchChange() {
    const term = this.globalSearchTerm.toLowerCase();

    if (!term) {
      this.filteredOprPallets = [...this.temp];
      return;
    }

    this.filteredOprPallets = this.filteredOprPallets.filter(pallet => {
      return Object.values(pallet).some(val =>
        val != null && val.toString().toLowerCase().includes(term)
      );
    });
  }

  toDateOnly(d: string | Date): string {
    return new Date(d).toISOString().split('T')[0];
  }


  exportParcelsToExcel(): void {
    const exportData = this.filteredOprPallets.flatMap(pallet => {
      return pallet.comPallets.filter(c => c.palletComplementaryValueNumber != null && c.palletComplementaryValueNumber !== '')
        .sort((a, b) => Number(a.palletComplementaryValueNumber) - Number(b.palletComplementaryValueNumber)).map(com => ({
        'Codice Pallet': pallet.palletCode,
        'Codice Bolla': pallet.palletWaybillCode,
        'Data Affido': this.formatDate(pallet.palletDate),
        'Stato': com.palletComplementaryValueNumber,
        'Data Stato': this.formatDate(com.palletComplementaryValueDate),
        'Magazzino': com.warehouseCodeName,
        'Vettore': com.carrierName,
        'Tipo Consegna': pallet.palletDeliveryType,
        'Codice Dealer': pallet.palletDealerCode,
        'Dealer': pallet.dealerName,
        'Indirizzo Dealer': pallet.dealerOperatingAddressStreet,
        'Città Dealer': pallet.dealerOperatingAddressCity,
        'Data Consegna Effettiva': pallet.palletStatus === 'DELIVERED' ? this.formatDate(pallet.palletActualDeliveryDate) : '',
        'Data Consegna Stimata': this.formatDate(pallet.palletEstimatedDeliveryDate),
        'Regione': pallet.regionName,
        'Codice Spedizione': pallet.palletShipmentCode
      }));
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const blobData = new Blob([excelBuffer], { type: 'application/octet-stream' });
    const now = new Date();
    const timestamp = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds().toString().padStart(2, '0')}`;

    FileSaver.saveAs(blobData, `pallets-history_${timestamp}.xlsx`);
  }

  private translatePalletStatus(status: string): string {
    switch (status) {
      case 'REQUEST_RETURN': return 'Richiesta di reso';
      case 'PICKED_UP': return 'Preso in carico';
      case 'SUSPENDED': return 'Sospeso';
      case 'DELIVERED': return 'Consegnato';
      default: return status;
    }
  }

  // Formatta date in formato dd/MM/yyyy HH:mm
  private formatDate(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }


  resetFilters(): void {
    this.palletStatus = '';
    this.searchPalletCode = '';
    this.searchWaybillCode = '';

    // Applica di nuovo il filtro (se necessario)
    this.applyFilters();
  }

}

